<template>
  <div>
    <b-modal ref="my-modal" size="lg" centered hide-footer title="Export Attendance Report">
      <form>
        <div class="middle-component">
        <label for="" class="labels ml-5">Select date(Daily)</label>
        <b-row>
          <b-col md="1"></b-col>
          <b-col md="8">
            <date-picker
              type="date"
              v-model="addDate"
              placeholder="Input Date to Search"
            ></date-picker>
          </b-col>
          <b-col md="2" class="d-flex">
            <b-button
              class="float-right"
              v-b-tooltip.hover.top
              title="Export to Excel (Daily)"
              @click="doExportCsv"
              variant="primary"
              type="submit"
              ><font-awesome-icon icon="download"></font-awesome-icon
            ></b-button>
            <b-button
              v-b-tooltip.hover.top
              title="Export to PDF (Daily)"
              @click="doExportToPDF"
              variant="warning"
              class="ml-2 btn-download"
            >
              <i class="fas fa-file-pdf"></i>
            </b-button>
          </b-col>
        </b-row>
        </div>
      </form>

      <form class="mt-4">
        <label for="" class="labels ml-5">Select month & year (Export Monthly)</label>
        <b-row class="mt-2">
          <b-col md="1"></b-col>
          <b-col md="8">
            <vue-monthly-picker
              :inputClass="{ input: isDisplayInput }"
              :monthLabels="locale"
              :min="min"
              :max="max"
              @selected="handleSelect"
              :selectedBackgroundColor="selectedBackgroundColor"
              v-model="model.selectedMonth"
            >
            </vue-monthly-picker>
          </b-col>
          <b-col md="2" class="d-flex">
            <b-button
              class="float-right"
              v-b-tooltip.hover.top
              @click="doExportExcelMonthly"
              title="Export to Excel (Monthly)"
              variant="primary"
              type="submit"
              ><font-awesome-icon icon="download"></font-awesome-icon
            ></b-button>
            <b-button
              v-b-tooltip.hover.top
              @click="doExportPDFMonthly"
              title="Export to PDF (Monthly)"
              variant="warning"
              class="ml-2 btn-download"
            >
              <i class="fas fa-file-pdf"></i>
            </b-button>
          </b-col>
        </b-row>
        <b-button class="mt-5 btn btn-outline-danger" variant="outline" @click="hideModal"
          ><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button
        >
      </form>
    </b-modal>
  </div>
</template>
<script>
import moment from 'moment';
import VueMonthlyPicker from 'vue-monthly-picker';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  components: { VueMonthlyPicker, DatePicker },
  data() {
    return {
      addDate: new Date(),
      disabled: false,
      min: null,
      max: null,
      apiUrl: {
        exportAttendanceToday: window.AppConfig.apiUrl + 'export-attendance-today',
        exportPdfToday: window.AppConfig.apiUrl + 'export-attendance-pdf',
        exportExcelMonthly: window.AppConfig.apiUrl + 'export-attendance-monthly-excel',
        exportPdfMonthly: window.AppConfig.apiUrl + 'export-attendance-monthly-pdf',
      },
      selectedBackgroundColor: '#89CFF0',
      isLimitRange: false,
      isDisplayInput: true,
      model: {
        selectedMonth: moment(),
      },
      locale: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    };
  },
  computed: {
    rangeDisplay() {
      if (!this.min || !this.max) {
        return 'Disabled';
      }
      return this.min.format('YYYY/MM') + '-' + this.max.format('YYYY/MM');
    },
  },

  watch: {
    isLimitRange(newValue) {
      if (newValue) {
        this.setSelectRange(moment().subtract(6, 'months'), moment().add(6, 'months'));
      } else {
        this.setSelectRange(null, null);
      }
    },
  },

  methods: {
    // doSubmit() {
    //   alert(this.getDateTime(this.model.selectedMonth));
    // },

    showModal() {
      this.model.selectedMonth = '';
      this.$validator.reset();
      this.$refs['my-modal'].show();
    },
    hideModal() {
      this.$refs['my-modal'].hide();
    },
    handleSelect(value) {
      console.log('Select', value);
    },
    setSelectRange(min, max) {
      this.min = min;
      this.max = max;
    },

    /**
     * function to export excell
     * EXPORT EXCEL MONTHLY
     */

    doExportExcelMonthly() {
      let url = this.apiUrl.exportExcelMonthly + '?token=' + this.$store.getters['account/tokens'].access_token;
      if ( this.$moment(this.model.selectedMonth).format('MM-YYYY') !== undefined && this.$moment(this.model.selectedMonth).format('MM-YYYY') !== null ) {
        url += '&monthyear=' + this.$moment(this.model.selectedMonth).format('MM-YYYY');
      }
      window.open(url);
    },

    /**
     * function export report monthly format PDF
     * EXPORT PDF MONTHLY
     */
    doExportPDFMonthly(){
      let url = this.apiUrl.exportPdfMonthly + '?token=' + this.$store.getters['account/tokens'].access_token;
      if(this.$moment(this.model.selectedMonth).format('MM-YYYY') !== undefined && this.$moment(this.model.selectedMonth).format('MM-YYYY') !== null)
      {
        url += '&monthyear=' + this.$moment(this.model.selectedMonth).format('MM-YYYY')
      }
      window.open(url)
    },

    /**
     * export csv day
     */
    doExportCsv() {
      let url = this.apiUrl.exportAttendanceToday + '?token=' + this.$store.getters['account/tokens'].access_token;
      if (this.$moment(this.addDate).format('YYYY-MM-DD') !== undefined && this.$moment(this.addDate).format('YYYY-MM-DD') !== null) {
        url += '&date=' + this.$moment(this.addDate).format('YYYY-MM-DD');
      }
      window.open(url);
    },

    /**
     *  export report pdf
     *  day
     * */
    doExportToPDF() {
      let url = this.apiUrl.exportPdfToday + '?token=' + this.$store.getters['account/tokens'].access_token;
      if ( this.$moment(this.addDate).format('YYYY-MM-DD') !== undefined && this.$moment(this.addDate).format('YYYY-MM-DD') !== null) {
        url += '&date=' + this.$moment(this.addDate).format('YYYY-MM-DD');
      }
      window.open(url);
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM');
      } else {
        return '-';
      }
    },
  },
};
</script>
<style scoped>
</style>